module.exports = __webpack_public_path__ + "img/pen-01.52074cd0.png";